/* eslint-disable import/extensions */
/* eslint-disable notice/notice */

export default {
  'ui/features/registration/jquery/index.js': () =>
    import(
      '../../../gems/plugins/instructure_misc_plugin/app/coffeescripts/extensions/registration/main.js'
    ),
  'ui/shared/signup-dialog/jquery/index.js': () =>
    import(
      '../../../gems/plugins/instructure_misc_plugin/app/coffeescripts/extensions/registration/signupDialog.js'
    ),
  'ui/features/content_migrations/setup.js': () =>
    import(
      '../../../gems/plugins/migration_tool/app/coffeescripts/extensions/modules/content_migration_setup.js'
    ),
  'ui/features/content_migrations/instui_setup.tsx': () =>
    import(
      '../../../gems/plugins/migration_tool/app/coffeescripts/extensions/modules/content_migration_setup.js'
    ),
  'ui/features/account_settings/index.jsx': () =>
    import(
      '../../../gems/plugins/multiple_root_accounts/app/jsx/bundles/account_quota_settings.jsx'
    ),
}
